import { V as e, a as r, b as y, c as J, d as t, e as V, f as i, _ as n, g as l, h as g, i as c, j as p, k as u, l as d, m, n as T, o as S, p as b, q as _, r as f, s as h, J as D, t as k, u as B, v as C, w as I, x as L, y as P, z as v, A as w, B as F, C as x, D as j, E as A, F as $, G as R, H as M, I as O, K as W, L as z, M as E, N as G, O as H, P as U, Q as q, R as K, S as N, T as Q, U as X, W as Y, X as Z, Y as aa, Z as oa, $ as sa, a0 as ea, a1 as ra, a2 as ya, a3 as Ja, a4 as ta, a5 as Va, a6 as ia, a7 as na, a8 as la, a9 as ga, aa as ca, ab as pa, ac as ua, ad as da, ae as ma, af as Ta, ag as Sa, ah as ba, ai as _a, aj as fa, ak as ha, al as Da } from "./style-ChThEVbr.js";
import { am as Pa, an as va } from "./style-ChThEVbr.js";
const ka = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VJoyAvailability: e,
  VJoyAvatar: r,
  VJoyAvatarsList: y,
  VJoyBadge: J,
  VJoyBadgeLevel: t,
  VJoyBlockSkeleton: V,
  VJoyBottomSheet: i,
  VJoyBottomSheetTrigger: n,
  VJoyButton: l,
  VJoyCheckbox: g,
  VJoyCollapse: c,
  VJoyCollapseItem: p,
  VJoyCompanyAvatar: u,
  VJoyCounter: d,
  VJoyDialog: m,
  VJoyDialogTrigger: T,
  VJoyDividerCta: S,
  VJoyDot: b,
  VJoyDrawer: _,
  VJoyDrawerTrigger: f,
  VJoyDropdown: h,
  VJoyDropdownList: D,
  VJoyDropzone: k,
  VJoyFilterBar: B,
  VJoyFilterBarButton: C,
  VJoyFooter: I,
  VJoyFormError: L,
  VJoyFormFieldSkeleton: P,
  VJoyFunnel: v,
  VJoyFunnelFooter: w,
  VJoyHeader: F,
  VJoyHighlight: x,
  VJoyIcon: j,
  VJoyIndicator: A,
  VJoyIndicators: $,
  VJoyInput: R,
  VJoyLabel: M,
  VJoyLink: O,
  VJoyListItem: W,
  VJoyMenu: z,
  VJoyMultiCheckbox: E,
  VJoyPagination: G,
  VJoyPanel: H,
  VJoyPanelSection: U,
  VJoyProductTour: q,
  VJoyProductTourTrigger: K,
  VJoyProgressBar: N,
  VJoyRadio: Q,
  VJoyRadioGroup: X,
  VJoyRatingStars: Y,
  VJoyScreenLoader: Z,
  VJoySelect: aa,
  VJoySelectableItem: oa,
  VJoySelectableItemGroup: sa,
  VJoySeparator: ea,
  VJoySnackbar: ra,
  VJoySpinner: ya,
  VJoyStep: Ja,
  VJoyStepper: ta,
  VJoyTab: Va,
  VJoyTabs: ia,
  VJoyTag: na,
  VJoyTagsInput: la,
  VJoyTagsList: ga,
  VJoyTemplate: ca,
  VJoyTemplateShape: pa,
  VJoyText: ua,
  VJoyTextarea: da,
  VJoyToggle: ma,
  VJoyTooltip: Ta,
  VJoyUserCard: Sa,
  VJoyWalkthrough: ba,
  VJoyWalkthroughTrigger: _a,
  VJoyWrapper: fa
}, Symbol.toStringTag, { value: "Module" })), Ca = {
  install: (a) => {
    Object.entries(ka).forEach(([o, s]) => {
      a.component(o, s);
    }), typeof window < "u" && ha(), a.directive("joy-ripple", Da);
  }
};
export {
  Ca as JoyVuePlugin,
  e as VJoyAvailability,
  r as VJoyAvatar,
  y as VJoyAvatarsList,
  J as VJoyBadge,
  t as VJoyBadgeLevel,
  V as VJoyBlockSkeleton,
  i as VJoyBottomSheet,
  n as VJoyBottomSheetTrigger,
  l as VJoyButton,
  g as VJoyCheckbox,
  c as VJoyCollapse,
  p as VJoyCollapseItem,
  u as VJoyCompanyAvatar,
  d as VJoyCounter,
  m as VJoyDialog,
  T as VJoyDialogTrigger,
  S as VJoyDividerCta,
  b as VJoyDot,
  _ as VJoyDrawer,
  f as VJoyDrawerTrigger,
  h as VJoyDropdown,
  D as VJoyDropdownList,
  k as VJoyDropzone,
  B as VJoyFilterBar,
  C as VJoyFilterBarButton,
  I as VJoyFooter,
  L as VJoyFormError,
  P as VJoyFormFieldSkeleton,
  v as VJoyFunnel,
  w as VJoyFunnelFooter,
  F as VJoyHeader,
  x as VJoyHighlight,
  j as VJoyIcon,
  A as VJoyIndicator,
  $ as VJoyIndicators,
  R as VJoyInput,
  M as VJoyLabel,
  O as VJoyLink,
  W as VJoyListItem,
  z as VJoyMenu,
  E as VJoyMultiCheckbox,
  G as VJoyPagination,
  H as VJoyPanel,
  U as VJoyPanelSection,
  q as VJoyProductTour,
  K as VJoyProductTourTrigger,
  N as VJoyProgressBar,
  Q as VJoyRadio,
  X as VJoyRadioGroup,
  Y as VJoyRatingStars,
  Z as VJoyScreenLoader,
  aa as VJoySelect,
  oa as VJoySelectableItem,
  sa as VJoySelectableItemGroup,
  ea as VJoySeparator,
  ra as VJoySnackbar,
  ya as VJoySpinner,
  Ja as VJoyStep,
  ta as VJoyStepper,
  Va as VJoyTab,
  ia as VJoyTabs,
  na as VJoyTag,
  la as VJoyTagsInput,
  ga as VJoyTagsList,
  ca as VJoyTemplate,
  pa as VJoyTemplateShape,
  ua as VJoyText,
  da as VJoyTextarea,
  ma as VJoyToggle,
  Ta as VJoyTooltip,
  Sa as VJoyUserCard,
  ba as VJoyWalkthrough,
  _a as VJoyWalkthroughTrigger,
  fa as VJoyWrapper,
  ha as createAllSnackbarsContainer,
  Pa as pushVJoySnackbar,
  va as resetCount,
  Da as vJoyRipple
};
